<section class="main-section">
  <!-- Content Area -->
  <div class="content-area">
    <div class="icon-circle">
      <img src="assets/images/master/delete-icon.svg" class="icon" alt="delete">
    </div>
    <h2 class="dialog-title">Delete Template?</h2>
    <p class="dialog-desc">
      Are you sure you want to delete this template?<br>
      This action cannot be undone.
    </p>
  </div>

  <!-- Buttons Footer -->
  <div class="button-section">
    <button type="button" class="cancel-button" (click)="closeBtn()">
      Go Back
    </button>
    <button type="button" class="apply-button" (click)="deleteComponent()" [disabled]="deleteIconLoader">
      <span *ngIf="deleteIconLoader"><i class="fas fa-spinner fa-spin"></i>&nbsp;Loading</span>
      <span *ngIf="!deleteIconLoader">Yes, Delete</span>
    </button>
  </div>
</section>